<template>
  <div>

    <xolas-table
        title="Sharers"
        table-ref="telcotable"
        icon="fa fa-users"
        :url="'/licensees/site/' + siteData.id + (this.telcoId ? '/licensee/' + this.telcoId : '')"
        :fields="fields"
        :showSearch="false"
        :layer-component="'licensee'"
        :layer-args="{ id: 'id' }">

      <template v-if="!noAdd" #actions>
        <sharer-action :row-data="rowData" :site-id="rowData.id" :read-only="readOnly" />
      </template>

      <template #lic-controls="props">
        <lic-controls :row-data="props.rowData" />
      </template>

    </xolas-table>
    </div>
</template>


<script>

import Vue from 'vue'

import SiteMixins from '@/mixins/SiteMixins'

import SharerAction from '@/components/actions/SharerAction'

import LicenseeControls from '@/components/sites/sharers/LicenseeControls'
import XolasTable from '@/components/atoms/tables/XolasTable'

Vue.component('lic-controls', LicenseeControls)

export default {
  mixins: [SiteMixins],

  components: {
    SharerAction,
    LicenseeControls,
    XolasTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    noAdd: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  methods: {
    formatSharerStatus (value) {
      let color = 'text-primary'

      if (value === 'Terminated') {
        color = 'text-danger'
      }

      return '<b class="' + color + '">' + value + '</b>'
    }
  },

  data () {
    return {

      telcoId: this.isTelco() ? Number(this.org().id) : null,

      siteData: this.rowData,

      // Per-column min/fixed widths: el-table uses fixed table-layout and
      // distributes width equally across un-sized columns, which starved the
      // Telco name column and wrapped long org names. The legacy vuetable used
      // content-based (auto) layout. minWidth gives el-table proportional hints
      // so text columns (esp. Telco) get the room they need (XOL-231).
      fields: [
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          callback: this.formatSharerStatus,
          minWidth: '100'
        },
        {
          // Single Telco column (full name) shown at all breakpoints. The old
          // table used two responsive columns (full name + mobile short name),
          // but a CSS-hidden column misaligns el-table's fixed table-layout and
          // shifts every column after it, so we keep one flexible name column
          // (XOL-231). It absorbs the table's leftover width.
          name: 'organisation.name',
          title: 'Telco',
          minWidth: '320'
        },
        {
          name: 'telcoSiteId',
          title: 'Site ID',
          sortField: 'telcoSiteId',
          minWidth: '110'
        },
        {
          title: 'Service',
          name: 'serviceType',
          sortField: 'serviceType',
          minWidth: '95'
        },
        {
          title: 'Spectrum',
          name: 'spectrumBand',
          sortField: 'spectrumBand',
          minWidth: '120'
        },
        {
          name: 'started',
          title: 'Started',
          sortField: 'started',
          callback: 'formatDate|D MMM YYYY',
          minWidth: '115'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          sortField: 'expiry',
          callback: 'formatDate|D MMM YYYY',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: '115'
        },
        {
          name: '__slot:lic-controls',
          title: '',
          visible: !this.readOnly,
          width: '60'
        }
      ]

    }
  }
}

</script>
